import { Component, ComponentFactoryResolver, OnInit, ViewChild,ViewContainerRef } from '@angular/core';
import { AspMyRequestService } from '../asp-my-request/asp-my-request.service';
import { AspInstantRequestComponent } from '../asp-instant-request/asp-instant-request.component';

@Component({
  selector: 'app-asp-clutch-kit-flow',
  templateUrl: './asp-clutch-kit-flow.component.html',
  styleUrls: ['./asp-clutch-kit-flow.component.scss']
})
export class AspClutchKitFlowComponent implements OnInit {
  insurance: any;
  isInsurance: boolean;
  openEdit: boolean;
  openEditIndex: number | null = null;
  selectedType: string;
  showError: boolean;
  selectedCompany: string;
  filteredList: string[];
  showError1: boolean;
  @ViewChild('intstantorder', { read: ViewContainerRef }) containers!: ViewContainerRef;
  constructor(
    private aspMyRequestService: AspMyRequestService,
    private resolver: ComponentFactoryResolver,
  ) { }

  ngOnInit(): void {
  }
  // loadrequest() {alert("click")

  //   // If insurance NOT loaded → load first
  //   if (!this.insurance || this.insurance.length === 0) {
  //     this.getInsurance();
  //     return;
  //   }

  //   // If insurance exists and not step-2 → open insurance sidebar
  //   if (this.insurance.length > 0 && localStorage.getItem('instantOrder') !== '2') {

  //     this.isInsurance = true;
  //     this.openEdit   = false;
  //     this.selectedType    = '';
  //     this.selectedCompany = '';
  //     this.showError  = false;
  //     this.showError1 = false;

  //     return;
  //   }

  //   // Else open instant request
  //   this.openInstantSidebar();
  // }
  loadrequest() {
    this.openInstantSidebar();
  }
    getInsurance() {
    this.aspMyRequestService.getInsurance().subscribe(result => {

      this.insurance = result['data'] || [];

      // ✅ ALWAYS re-trigger open after API completes
      this.loadrequest();

    });
  }
  toggleEditMenu(index: number, event: Event) {
    event.stopPropagation();
    this.openEditIndex = this.openEditIndex === index ? null : index;
  }
  skip() {
    this.isInsurance = false;
    this.openEdit = false;
    localStorage.removeItem("isInsurance");
    localStorage.removeItem('insuranceGarageKey');
    this.openInstantSidebar();  // ✅ Direct open
  }
  continue(): void {

    if (!this.selectedType) {
      this.showError = true;
      return;
    }

    if (this.selectedType === 'insurance' && !this.selectedCompany) {
      this.showError1 = true;
      return;
    }

    this.isInsurance = false;

    const type = this.selectedType === 'insurance';
    localStorage.setItem("isInsurance", String(type));
    localStorage.setItem('insuranceGarageKey', this.selectedCompany);

    this.openInstantSidebar();   // ✅ Open the main sidebar now
  }
  openInstantSidebar() {
    localStorage.setItem('clutchFlow', '1');
    if (!this.containers) {
      console.error('❌ Container not found');
      return;
    }

    this.containers.clear();

    const factory = this.resolver.resolveComponentFactory(AspInstantRequestComponent);
    const componentRef = this.containers.createComponent(factory);

    const instance = componentRef.instance as AspInstantRequestComponent;

    // ✅ ADD THIS LINE
    instance.fromClutchFlow = true;

    console.log('✅ Component created:', componentRef);

    if (localStorage.getItem('instantOrder') === '2') {
      instance.closeDetails(true);
      instance.openSidebar(true);
    } else {
      instance.closeDetails(false);
      instance.openSidebar(true);
      localStorage.removeItem('carNumber');
    }
  }
    ngAfterViewInit() {
    // just to confirm container is ready
    console.log(this.containers);
  }
}
